// extracted by mini-css-extract-plugin
export default {"form":"create-project_form__sD2af","error":"create-project_error__H39Pc"};